import * as React from 'react';

import {List} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledList = styled(List)(({ theme }) => ({
    padding:0,
    '& .MuiListItem-root': {
        borderBottom: '1px dashed #ddd',
        padding: '1rem 0.5rem',
        '&:hover': {
            backgroundColor: '#f9f9f9',
        },
        '&:last-child': {
            borderBottom: 'none',
        },
        '& .MuiListItemText-root':{
            [theme.breakpoints.up('xs')]: {
                justifyContent: 'flex-start',
                display: 'block',
            },
            [theme.breakpoints.up('md')]: {
                justifyContent: 'space-between',
                display: 'flex',
            },
            marginBottom:'5px',
            '& span':{
                fontSize: '1rem',
                color: '#444444',
                lineHeight: '22px',
            },
            '& p':{
                color: '#222222',
                fontSize:'1.1rem',
                fontWeight:'400',
                lineHeight: '22px',
                textAlign:{
                    xs:'left',
                    sm:'right'
                },
            }
        }
    },
}));

export const DefinitionList = ({children, props}) => {

    return (
        <StyledList {...props}>
            {children}
        </StyledList>
    )
}